// Ask Adam (ClientSpace.dc.html): the first press opens the box, the second sends it as a question
// with a link to this space (hub.questions with client_space_id, so only the client and an owner or
// admin can read it, and its flag waits on Today for stage 5). An empty question sends nothing.
// Only the client can ask: in Adam's view, and while staff view as the client, the button is off.
import { useState } from 'react'
import { readOnlyControl, VIEWING_AS_LINE } from '../../lib/viewAs.jsx'
import { COPY } from './copy.js'
import { spacePath } from './model.js'
import { askInSpace } from './data.js'

export function AskAdamCard({ ctx }) {
  const { product, space, staff, viewingAs, me } = ctx
  const [open, setOpen] = useState(false)
  const [text, setText] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)
  const off = staff || viewingAs

  async function ask() {
    if (off || busy) return
    if (!open) { setOpen(true); setSent(false); setMsg(null); return }
    const body = text.trim()
    if (!body) return
    setBusy(true)
    setMsg(null)
    try {
      await askInSpace({ personId: me.person.id, spaceId: space.id, contextPath: spacePath(product, space.id), body })
      setOpen(false)
      setText('')
      setSent(true)
    } catch {
      setMsg(COPY.notSent)
    } finally {
      setBusy(false)
    }
  }

  const control = staff ? { disabled: true, 'aria-disabled': 'true', title: COPY.askAdamView } : readOnlyControl(viewingAs)
  return (
    <section className="ms-ask" data-part="ask" aria-labelledby="ms-ask-h">
      <h2 className="ms-h2 ms-h2--small" id="ms-ask-h">{COPY.askH2}</h2>
      <span className="ms-ask-line">{COPY.askLine}</span>
      {open && (
        <textarea aria-label={COPY.askAria} value={text} maxLength={4000} placeholder={COPY.askPlaceholder}
          autoFocus onChange={e => setText(e.target.value)} />
      )}
      <button type="button" className="ms-btn ms-btn--small" onClick={ask} disabled={busy} {...control}>
        {open ? COPY.askSend : COPY.askOpen}
      </button>
      {sent && <span className="ms-ask-sent" role="status">{COPY.askSent}</span>}
      {msg && <span className="ms-ask-msg" role="alert">{msg}</span>}
      {viewingAs && !staff && <span className="ms-ask-note">{VIEWING_AS_LINE}</span>}
    </section>
  )
}
